<cam-layout-side class="d-flex full-width">
  <cam-layout-side-content>
    <div class="documents-attachments-container flex-column">
      <div class="view mt-space-md">
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
      </div>
    </div>
  </cam-layout-side-content>
  <cam-layout-side-cta>
    <div class="cta space-between align-center">
      <cam-link
        [state]="!this.allUploadsCompleted() ? 'disabled' : 'classic'"
        (action)="this.close()"
        icon="close-tool"
        size="sm"
      >
        {{ 'files.attachments-modal.cancel' | translate }}
      </cam-link>
      <cam-button
        [state]="!this.allUploadsCompleted() ? 'disabled' : 'classic'"
        icon="check-line"
        (action)="this.confirm()"
      >
        {{ 'files.attachments-modal.confirm' | translate }}
      </cam-button>
    </div>
  </cam-layout-side-cta>
</cam-layout-side>

<ng-template #contentTemplate>
  @switch (this.view) {
    @case (this.EAttachmentsModalView.linkedDocuments) {
      <div class="mb-space-md space-between align-center">
        <cam-title [level]="3" [isBold]="true">
          {{ 'files.attachments-modal.title.add-linked-document' | translate }}
        </cam-title>
      </div>
      <div class="mb-space-md">
        <cam-menu-navigation container="tags" [menu]="this.sectionsHelper().menu"></cam-menu-navigation>
      </div>
      @if (this.sectionsHelper().filterHelper.filter !== this.UPLOADED_DOCUMENTS_KEY) {
        <div class="mb-space-md">
          <cam-search-field
            [isOpen]="true"
            [input]="this.searchInput"
            placeholder="files.attachments-modal.search"
            (valueChanged)="this.onSearch($any($event))"
          ></cam-search-field>
        </div>
      }
      <cam-loader [isLoading]="this.requestState.isLoading()">
        <div class="content">
          <ng-container [ngTemplateOutlet]="documentDetailTemplate"></ng-container>
        </div>
      </cam-loader>
      <ng-container [ngTemplateOutlet]="buttonTemplate"></ng-container>
    }
    @case (this.EAttachmentsModalView.newDocuments) {
      <div class="mb-space-md space-between align-center">
        <cam-title [level]="3" [isBold]="true">
          {{ 'files.attachments-modal.title.add-new-document' | translate }}
        </cam-title>
      </div>
      <cam-input-upload
        [standalone]="true"
        [input]="this.uploadInput"
        (uploadStatusChanged)="this.updateUploadStatus($event)"
      >
      </cam-input-upload>
      <ng-container [ngTemplateOutlet]="buttonTemplate"></ng-container>
    }
  }
</ng-template>

<ng-template #documentDetailTemplate>
  @if (this.sectionsHelper().filterHelper.filter === this.UPLOADED_DOCUMENTS_KEY) {
    <cam-documents-list
      [documentsIds]="this.sectionsHelper().extractIds(this.uploadInput.value)"
      [emptyMessage]="'files.attachments-modal.empty-message.uploaded'"
      actions="delete"
      (remove)="this.removedUploadDocument($event)"
    ></cam-documents-list>
  }
  @for (section of this.sectionsHelper().sections; track section.key) {
    @if (this.sectionsHelper().filterHelper.filter === section.key) {
      <cam-documents-list
        [documentsIds]="this.documentsIds()[section.key]"
        [emptyMessage]="section.emptyMessage"
        [search]="this.search()"
        [defaultSelected]="this.sectionsHelper().extractIds(this.sectionsHelper().documentsSelected[section.key])"
        actions="select"
        (checkedFilesChanged)="this.sectionsHelper().onSelectedChange(section.key)($event)"
      ></cam-documents-list>
    }
  }
</ng-template>

<ng-template #buttonTemplate>
  @switch (this.view) {
    @case (this.EAttachmentsModalView.linkedDocuments) {
      <div class="display-button space-between align-center g-space-md">
        <cam-button
          size="small"
          type="secondary"
          icon="add"
          (action)="this.switchView(this.EAttachmentsModalView.newDocuments)"
        >
          {{ 'files.attachments-modal.cta.add-new-document' | translate }}
        </cam-button>
        <div class="flex-row g-space-sm">
          <cam-button
            size="small"
            type="secondary"
            icon="check-line"
            [state]="this.canSelectAll() ? 'classic' : 'disabled'"
            (action)="this.selectAll()"
          >
            {{ 'files.attachments-modal.cta.select-all' | translate }}
          </cam-button>
          <cam-button
            size="small"
            type="secondary"
            icon="close-tool"
            [state]="this.canUnselectAll() ? 'classic' : 'disabled'"
            (action)="this.unselectAll()"
          >
            {{ 'files.attachments-modal.cta.unselect-all' | translate }}
          </cam-button>
        </div>
      </div>
    }
    @case (this.EAttachmentsModalView.newDocuments) {
      <div class="display-button d-flex">
        <cam-button
          size="small"
          type="secondary"
          icon="add"
          (action)="this.switchView(this.EAttachmentsModalView.linkedDocuments)"
        >
          {{ 'files.attachments-modal.cta.add-linked-document' | translate }}
        </cam-button>
      </div>
    }
  }
</ng-template>
